import React, { Component } from "react";
import { View } from "react-native";
import { MonoText } from "../StyledText";

class Comment extends React.Component {
  _getUpperCase(name) {
    return name.toUpperCase();
  }
  render() {
    return (
      <View style={{ marginTop: 2 }}>
        <div className="comment">
          <blockquote className="blockquote">
            {!this.props.parentId || this.props.parentId < 0 ? (
              <MonoText
                style={{
                  marginTop: 18,
                  color: this.props.colors.text,
                  fontWeight: "bold",
                  fontSize: 14,
                }}
              >
                <footer className="blockquote-footer">
                  {this.props.author}
                </footer>
              </MonoText>
            ) : (
              <>
                <footer className="blockquote-footer">
                  <MonoText
                    style={{
                      marginTop: 18,
                      color: this.props.colors.text,
                      fontSize: 14,
                    }}
                  >
                    {this.props.author + " (reply)"}
                  </MonoText>
                </footer>
              </>
            )}
            <p className="mb-0">
              <MonoText
                style={{
                  marginTop: 18,
                  color: this.props.colors.text,
                  fontSize: 14,
                }}
              >
                {this.props.body}{" "}
              </MonoText>
            </p>
            <p className="mb-0">
              <a
                href="#"
                onClick={() => {
                  this.props.replyCallback(this.props.id);
                }}
                className="comment-footer-delete"
              >
                {this.props.userId > 0 && (
                  <MonoText
                    style={{
                      marginTop: 18,
                      color: this.props.colors.text,
                      fontSize: 14,
                    }}
                  >
                    Reply
                  </MonoText>
                )}
              </a>
            </p>
          </blockquote>
        </div>
      </View>
    );
  }
}

export default Comment;
